import { useState, useEffect, useContext } from 'react'
import ServicesContext from 'Contexts/Services/Services.context'

export function useNotificationSMSEnabled(): [ boolean, boolean, typeof setEnabledSMS ] {
  const [ enabledSMS, setEnabledSMS ] = useState<boolean>(false)
  const [ loaded, setLoaded ] = useState<boolean>(false)
  const services = useContext(ServicesContext)

  useEffect(() => {
    const fetch = async () => {
      try {
        const result = await services.notificationService.getSMSEnablingChecked()
        if (result && result.isBannerChecked) {
          setEnabledSMS(true)
        }
        setLoaded(true)
      } catch (e) {
        //
      }
    }
    fetch()
  }, [])

  return [ enabledSMS, loaded, setEnabledSMS ]
}
